import { render, staticRenderFns } from "./ResourceCreation.vue?vue&type=template&id=0fd1f23f"
import script from "./ResourceCreation.vue?vue&type=script&lang=js"
export * from "./ResourceCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports